<template>
  <div class="dropdown" :class="{ open: isOpen }">
    <div class="caption" @click="toggleDropdown">
      <slot name="caption"></slot>
    </div>
    <div class="list" v-if="isOpen">
      <slot name="list"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DropdownMenu',
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>

<style>
</style>
